<template>
  <div class="row">
    <div class="col-sm-12 classic-pagination">
      <nav>
        <ul class="pagination mt-2 d-flex justify-content-end">
          <li class="page-item" aria-label="RowsPerPage" v-if="enable_rows_per_page">
            <SingleSelect v-model="rowsPerPage"
              name="rowsPerPage"
              label=""
              :options="rowsPerPageOptions"
              label-key="value"
              value-key="code"
              :show-clear="false"
              placeholder=""
              col-style="col-12 mb-2"
              @change="setLimit"/>
          </li>
          <li class="page-item" :class="{ disabled: isFirstPageDisabled }" aria-label="First">
            <a class="page-link" href="#" @click.prevent="setPage(1)">
              <span aria-hidden="true">&laquo;</span>
              <span class="sr-only">First</span>
            </a>
          </li>
          <li class="page-item" :class="{ disabled: isPrevPageDisabled }"  aria-label="Previous">
            <a class="page-link" href="#" @click.prevent="setPage(current_page-1)">
              <span aria-hidden="true">&lt;</span>
              <span class="sr-only">Previous</span>
            </a>
          </li>
          <li v-for="page in getPageRange()" :key="page" class="page-item" :class="{ active: current_page == page, disabled: isPageNumberDisabled }">
            <a class="page-link" href="#" @click.prevent="setPage(page)">{{page}}</a>
          </li>
          <li class="page-item" :class="{ disabled: isNextPageDisabled }" aria-label="Next">
            <a class="page-link" href="#" @click.prevent="setPage(current_page + 1)">
              <span aria-hidden="true">&gt;</span>
              <span class="sr-only">Next</span>
            </a>
          </li>
          <li class="page-item" :class="{ disabled: isLastPageDisabled }" aria-label="Last">
            <a class="page-link" href="#" @click.prevent="setPage(page_count)">
              <span aria-hidden="true">&raquo;</span>
              <span class="sr-only">Last</span>
            </a>
          </li>
        </ul>
        <span class="d-flex justify-content-end page-count">{{`Showing page ${current_page} of ${page_count}`}}</span>
      </nav>
    </div>
  </div>
</template>

<script lang="js">
import SingleSelect from "@/src/components/shared/FormComponents/SingleSelect.vue";

export default {
  props: {
    page_count: { default: null },
    current_page: { default: null },
    disabled: { default: false, type: Boolean }, // Disable pagination controls
    records_per_page: { default: 20, type: Number },
    enable_rows_per_page: { default: false, type: Boolean }
  },
  components: {
    SingleSelect
  },
  data() {
    return {
      selectedStatus: null,
      selectedTeam: null,
      searchString: null,
      showDismissed: null,
      params: new URLSearchParams(window.location.search),
      rowsPerPageOptions: [
        { code: '20', value: '20' },
        { code: '50', value: '50' },
        { code: '100', value: '100' }
      ]
    }
  },
  computed: {
    isFirstPageDisabled() {
      return this.disabled || this.current_page <= 1;
    },
    isPrevPageDisabled() {
      return this.disabled || this.current_page <= 1;
    },
    isPageNumberDisabled() {
      return this.disabled;
    },
    isNextPageDisabled() {
      return this.disabled || this.current_page >= this.page_count;
    },
    isLastPageDisabled() {
      return this.disabled || this.current_page >= this.page_count;
    },
    rowsPerPage() {
      return this.records_per_page.toString();
    }

  },
  mounted() {
    try {
      this.searchString = this.params.get('search') || null
      this.selectedStatus = this.params.get('status') || null
      this.showDismissed = this.params.get('show_dismissed') || null
      this.selectedTeam = this.params.get('team') || null
    }
    catch(error) {
      console.log(error)
    }
  },
  methods: {
    setPage(page) {
      if (this.disabled) {
        return;
      }
      this.$emit('updatePage', page)
    },
    getPageRange() {
      let pages = []
      if(this.current_page == 1) {
        for(let i = 0; i < this.page_count && i <=2; i++) {
          pages.push(this.current_page + i)
        }
      } 
      else if (this.current_page == this.page_count) {
        for(let i = this.page_count > 2 ? -2 : -1; i < this.page_count && i <= 0 && this.current_page + i > 0; i++) {
          pages.push(this.current_page + i)
        }
      }
      else {
        for(let i = -1; i <= 1; i++) {
          pages.push(this.current_page + i)
        }            
      }
      return pages
    },
    setLimit(value) {
      if (this.disabled) {
        return;
      }
      this.$emit('updateRowCount', value)
    }
  }
}
</script>
